/* eslint-disable @typescript-eslint/member-ordering */
import { saveAs } from 'file-saver';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../../helper/constants';
import { PcnModel } from '../../viewmodels/pcn.model';
import { AlertModel } from '../../viewmodels/alert.model';
import { LetterService } from '../../services/letter.service';
import { GlobalObservables } from '../../../../app.global.observer';
import { Global } from '../../../../app.global';
import { AlertsService } from '../../services/alerts.service';
import { bounceBubbleAnimation, flashAnimation } from '../../../../app.animations';
import { Subscription, SubscriptionLike as ISubscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { KeyDescriptionViewModel } from '../../viewmodels/keyDescriptionViewModel';
import { ChangeDecisionModel } from '../../viewmodels/change-decision.model';
import { DecisionsConst } from '../../helper/decisionsConst';
import { AuthenticationService } from '../../../../authentication/services/authentication.service';
import { QuestionsConst } from '../../helper/questionConst';
import { PcnBlockService } from '../../services/pcn-block.service';
import { InterfaceDocument } from '../../../../authentication/viewmodels/interface-document';
import { SettingsService } from '../../../../authentication/services/settings.service';
import { StorageService } from '../../services/storage.service';
import { DatePipe } from '@angular/common';
import { ReasonService } from '../../services/reason.service';
import { Router } from '@angular/router';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'letter',
  templateUrl: './letter.component.html',
  styleUrls: ['./letter.component.scss'],
  animations: [bounceBubbleAnimation, flashAnimation],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class LetterComponent implements OnInit, OnDestroy {
  @ViewChild('paragraphLabel') paragraphLabel: ElementRef;
  @ViewChild('paragraphsTooltip') paragraphsTooltip: ElementRef;
  @ViewChild('changeDecisionModal') changeDecisionModal: ElementRef;
  @ViewChild('bespokeLetterModal') bespokeLetterModal: ElementRef;
  @ViewChild('copyLetterBtn') copyLetterBtn: ElementRef;
  @ViewChild('customParagraphContent') customParagraphTooltip;
  @ViewChild('documentHelperFormatted') documentHelperFormatted;
  @ViewChild('documentHelper') documentHelper;
  @ViewChild('letterCkeditor') letterCkeditor;

  public constants = Constants;
  public letterContent = '';
  public showCopyBtn = false;
  public showCancelLetterDialog = false;
  public actionsLayout = 'normal';

  ckeditorContent = ``;
  ckeConfig: any;
  showCopyOptions = false;
  isCopyToastShown = false;
  clipboardTrialEnabled = false;
  spinnerStyle = 'spinner3';
  decisionStatus = this.decisionsConst.none.id;
  isCreateBespokeLetter: boolean;
  isModalSubmitted = false;
  customParagraphs = [];
  isParagraphTooltipVisible = false;
  isCustomLetterVisible = false;
  isCustomParagraphVisible = false;
  numberOfParagraphsSelected = 0;
  modalReference: any;
  bounceParagraphsBubbleState: any = 1;
  tooltipPlacement = 'right';
  letterGenerationError = '';
  loadingState = false;
  changeDecisionBespokeLetterError = '';
  formattedInputId = 'document-helper-formatted';
  unformattedInputId = 'document-helper';
  letterCkeditorId = 'letter-ckeditor-id';
  letterEventCode = '';
  letterEventDescription = '';
  hasEditLetterAccess = this.authService.hasEditLetterAccess();
  overrideDecisionStatus = '';
  customLetters: Array<AlertModel> = [];
  bounceLettersBubbleState: any = 1;
  isCustomLetter = false;
  datePipeEn: DatePipe = new DatePipe('en-UK');
  letterTextTypes: Array<KeyDescriptionViewModel> = [];
  letterTemplates: Array<KeyDescriptionViewModel> = [];
  letterTemplatedSelected = '';
  loadingMessage: string;

  private _isEditMode = false;
  private defaultMessage = 'loading';
  private loadingLetterMessage = 'loading letter';
  private waitingForQuestionsMessage = 'waiting for questions';
  private unansweredQuestionsMessage = 'please answer all questions';
  private noReasonsSelectedMessage = 'please select a reason';
  // Shown in the letterGenerationErrors block. These replace a busy spinner
  // that previously had nothing left to clear it, so they have to say what the
  // user can do next rather than only that something failed.
  private letterFailedMessage =
    'The letter could not be generated. Your answers have been kept - change an answer or reselect the letter template to try again.';
  private letterUnavailableMessage =
    'This case is not ready for a letter yet. Reopen the case from the PCN search to continue.';
  private questionsFailedMessage =
    'The questions could not be refreshed, so the letter has not been rebuilt. Your answers have been kept - change an answer to try again.';
  private latestLetterRequest: Subscription | null = null;
  private onPcnChangedEvent: ISubscription;
  private onQuestionsChangingEvent: ISubscription;
  private onQuestionsChangedEvent: ISubscription;
  private onQuestionsFailedEvent: ISubscription;
  private onDocumentsChangingEvent: ISubscription;
  private onDocumentsChangedEvent: ISubscription;
  private onAfterDocumentsSaved: ISubscription;
  private onDecisionSetActionEvent: ISubscription;
  private addCustomLetterSubscription: ISubscription;
  private removeCustomLetterSubscription: ISubscription;
  private addCustomParagraphSubscription: ISubscription;
  private removeCustomParagraphSubscription: ISubscription;
  private onCustomLettersChangedEvent: ISubscription;
  private onCustomParagraphsChangedEvent: ISubscription;
  private onReasonsChangingEvent: ISubscription;
  private onReasonsChangedEvent: ISubscription;
  private onAddCustomParagraphEvent: ISubscription;
  private onRemoveCustomParagraphEvent: ISubscription;
  private onAddCustomLetterEvent: ISubscription;
  private onRemoveCustomLetterEvent: ISubscription;

  private letterRequest$ = new Subject<void>();
  private letterRequestSubscription: Subscription;

  private _saveLetterLoading = false;
  private _buttonLabel = 'Save and Edit';

  constructor(
    public globalObs: GlobalObservables,
    public global: Global,
    private modalService: NgbModal,
    private letterService: LetterService,
    private alertsService: AlertsService,
    public decisionsConst: DecisionsConst,
    private authService: AuthenticationService,
    public questionsConst: QuestionsConst,
    private pcnService: PcnBlockService,
    private reasonService: ReasonService,
    private settingsService: SettingsService,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  // Reuses the same setting that already governs whether the "create letter"
  // icon shows on the NPS side - if a client has a configured NpsUrl, Relay is
  // considered rolled out for them, so it's safe to also show this button.
  showCopyToNpsFab = false;

  public get isEditMode(): boolean {
    return this._isEditMode;
  }
  public get saveLetterLoading(): boolean {
    return this._saveLetterLoading;
  }
  public get buttonLabel(): string {
    // console.log(`[DEBUG] buttonLabel: ${this._buttonLabel}`);
    return this._buttonLabel;
  }

  public set isEditMode(value: boolean) {
    this._isEditMode = value;
    // console.log('[DEBUG] isEditMode changed to:', value);
    this.updateButtonLabel();
  }
  public set saveLetterLoading(value: boolean) {
    this._saveLetterLoading = value;
    // console.log(`[DEBUG] saveLetterLoading changed to: ${value}`);
    this.updateButtonLabel();
  }

  ngOnInit() {
    this.loadingMessage = this.loadingLetterMessage;

    this.settingsService.getApplicationSetting('LetterEditor.NpsUrl').subscribe({
      next: (npsUrl) => (this.showCopyToNpsFab = !!npsUrl),
      error: () => (this.showCopyToNpsFab = false),
    });

    // set CKEditor configuration
    this.setCKEditorConfig();
    // set custom paragraphs
    this.setCustomParagraphs();
    // set tooltip placement
    this.setTooltipPlacement();
    // set letter text types
    this.setLetterTextTypes();
    // set letter templates
    this.setLetterTemplates();
    // set whether the clipboard format trial options are shown for this tenant
    this.setClipboardTrialEnabled();
    // set the council's chosen loading spinner style
    this.setSpinnerStyle();

    this.letterRequestSubscription = this.letterRequest$
      .pipe(debounceTime(500))
      .subscribe(() => this.executeGetLetterAsHtml());

    // Setup Observables
    this.onPcnChangedEvent = this.globalObs.onPcnChanged.subscribe(this.onPcnChanged);
    this.onQuestionsChangingEvent = this.globalObs.onQuestionsChanging.subscribe(() =>
      this.onQuestionsChanging()
    );
    this.onQuestionsChangedEvent = this.globalObs.getDebouncedOnQuestionsChanged().subscribe(() => {
      this.onQuestionsChanged();
    });
    this.onQuestionsFailedEvent = this.globalObs.onQuestionsFailed.subscribe(() =>
      this.onQuestionsFailed()
    );
    this.onReasonsChangingEvent = this.globalObs.onReasonsChanging.subscribe(() =>
      this.onReasonsChanging()
    );
    this.onReasonsChangedEvent = this.globalObs.onReasonsChanged.subscribe(this.onReasonsChanged);
    this.onAddCustomParagraphEvent = this.globalObs.addCustomParagraph.subscribe(() =>
      this.onAddCustomParagraph()
    );
    this.onRemoveCustomParagraphEvent = this.globalObs.removeCustomParagraph.subscribe(() =>
      this.onRemoveCustomParagraph()
    );
    this.onAddCustomLetterEvent = this.globalObs.addCustomLetter.subscribe(() =>
      this.onAddCustomLetter()
    );
    this.onRemoveCustomLetterEvent = this.globalObs.removeCustomLetter.subscribe(() =>
      this.onRemoveCustomLetter()
    );
    this.onDocumentsChangingEvent = this.globalObs.onDocumentsChanging.subscribe(() =>
      this.onDocumentsChanging()
    );
    this.onDocumentsChangedEvent = this.globalObs.onDocumentsChanged.subscribe(() =>
      this.onDocumentsChanged()
    );
    this.onCustomLettersChangedEvent = this.globalObs.onCustomLettersChanged.subscribe(() =>
      this.onCustomLettersChanged()
    );
    this.onCustomParagraphsChangedEvent = this.globalObs.onCustomParagraphsChanged.subscribe(() =>
      this.onCustomParagraphsChanged()
    );
    this.onDecisionSetActionEvent = this.globalObs.onDecisionSetAction.subscribe(
      (decision: string) => this.onDecisionSet(decision)
    );
  }

  toggleEditMode(shouldEdit: boolean) {
    this._isEditMode = shouldEdit;
    this.cdr.detectChanges(); // force sync detection
  }

  // Set configuration for CKEditor
  setCKEditorConfig() {
    this.ckeConfig = {
      versionCheck: false,
      allowedContent: true,
      disableNativeSpellChecker: false,
      extraPlugins: 'divarea',
      toolbarGroups: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        {
          name: 'editing',
          groups: ['find', 'selection', 'spellchecker', 'editing'],
        },
        { name: 'styles', groups: ['styles'] },
        { name: 'forms', groups: ['forms'] },
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'colors', groups: ['colors'] },
        {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
        },
        { name: 'insert', groups: ['insert'] },
        '/',
        { name: 'links', groups: ['links'] },
        '/',
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] },
      ],
      removeButtons:
        'Source,Save,Templates,NewPage,Preview,Print,Cut,Undo,Copy,Redo,Paste,PasteText,' +
        'PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,' +
        'ImageButton,HiddenField,Strike,Subscript,Superscript,RemoveFormat,Styles,CopyFormatting,' +
        'Indent,Outdent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Link,Unlink,' +
        'Anchor,Flash,Maximize,ShowBlocks,About,HorizontalRule,Smiley,SpecialChar,Iframe',
      removePlugins: 'contextmenu,liststyle,tabletools,tableselection',
    };
  }

  // Retrieves and sets the custom paragraphs
  /**
   * Takes the custom paragraphs from the shared result the header publishes.
   *
   * This used to call `getCustomParagraphs` itself, which put a second
   * concurrent writer of the server's AcceptedAlerts state on every PCN,
   * reasons and documents change - the header already fetches the same list.
   * The header now loads letters and paragraphs in order and publishes both,
   * so reading `global.customParagraphs` gives the same data with none of the
   * races.
   *
   * Called directly on init because `onCustomParagraphsChanged` is a plain
   * Subject with no replay: if the header published before this component
   * mounted, there is nothing to wait for.
   */
  setCustomParagraphs() {
    this.customParagraphs = this.global.customParagraphs ?? [];
    this.bounceParagraphsBubbleState = Math.random();
    this.setSelectedCustomParagraphs();
  }

  // Retrieves and sets the letter text types (Default, Formal, etc)
  setLetterTextTypes() {
    this.showSpinner(this.defaultMessage);
    this.pcnService.getLetterTextTypes().subscribe({
      next: (result) => {
        this.letterTextTypes = result;
      },
      error: (e) => {
        console.error('Error getting letter text types', e);
      },
      complete: () => {
        this.hideSpinner();
      },
    });
  }

  // Retrieves and sets the letter templates
  setLetterTemplates() {
    this.showSpinner(this.defaultMessage);
    this.pcnService.getLetterTemplates().subscribe({
      next: (result) => {
        this.letterTemplates = result;
      },
      error: (e) => {
        console.error('Error getting letter templates', e);
      },
      complete: () => {
        this.hideSpinner();
      },
    });
  }

  // Triggers when the letter text type is changed
  onLetterTextTypeChanged(textResourceGroup) {
    this.pcnService.setLetterText(textResourceGroup).subscribe({
      next: (result) => {
        if (result) {
          this.globalObs.onLetterTextTypeChanged.next(true);
        }
      },
      error: (e) => {},
      complete: () => {},
    });
  }

  // Triggers when the letter template is changed
  onLetterTemplateChanged(templateName) {
    this.pcnService.setLetterTemplate(templateName).subscribe({
      next: (result) => {
        if (result) {
          this.globalObs.letterTemplateChanged.next(true);
        }
      },
      error: (e) => {},
      complete: () => {},
    });
  }

  // configures the placement of tooltips
  setTooltipPlacement() {
    if (window.innerWidth <= this.constants.breakpoints.desktopSm) {
      this.tooltipPlacement = 'right';
    }
  }

  setSelectedCustomParagraphs() {
    this.alertsService.getSelectedAlerts().subscribe((result) => {
      if (result) {
        const selectedAlertsIds = [];
        result.forEach((alert) => {
          selectedAlertsIds.push(alert.id);
        });
        this.customParagraphs.forEach((paragraph) => {
          paragraph.selected = selectedAlertsIds.indexOf(paragraph.id) > -1;
          // || paragraph.paragraphAutoSelect.value;
        });
      }
    });
  }

  getNumberOfParagraphsSelected() {
    let parSelected = 0;
    this.customParagraphs.forEach((paragraph) => {
      if (paragraph.selected) {
        parSelected += 1;
      }
    });
    return parSelected;
  }

  onParagraphSelected(paragraph) {
    this.showSpinner(this.defaultMessage);
    this.alertsService.addRemoveParagraph(paragraph.id).subscribe({
      next: (result) => {
        // console.log('onParagraphSelected calling getLetterAsHtml');
        this.getLetterAsHtml();
      },
      error: (e) => {},
      complete: () => {
        this.hideSpinner();
      },
    });
  }

  onPcnChanged(PCN: PcnModel) {
    // Paragraphs arrive through onCustomParagraphsChanged, once the header has
    // loaded them for the new case. Reading them here would read the old ones.
  }

  saveEditDocument() {
    // save document here
    if (this.isEditMode) {
      // console.log("Calling saveInterfaceAndEditedLetter");
      this.saveInterfaceAndEditedLetter();
      // console.log("Completed saveInterfaceAndEditedLetter");
    } else {
      this.saveLetterLoading = true;
      // console.log("Calling savePreviewLetter");

      this.letterService.savePreviewLetter().subscribe({
        next: (result) => {
          if (result) {
            this.letterContent = this.ckeditorContent;
            // console.log(`[DEBUG] isEditMode Before: ${this.isEditMode}`);
            // this.isEditMode = !this.isEditMode;
            this.toggleEditMode(true);
            this.saveLetterLoading = false;

            // console.log(`[DEBUG] isEditMode After: ${this.isEditMode}`);
            this.cdr.markForCheck();
            this.showCopyBtn = true;
            // close the pcn, "lock" the pcn-block, questions and letter functions
            this.globalObs.onLetterSaved.next();
            this.pcnService.setClosePcn(true);
            this.storageService.lockReasons(true); // lock the reason "panel" while we edit the letter
            this.storageService.lockLetterTop(true); //  lock the top part of the letter "panel" while we edit the letter
            this.storageService.lockPcnDetails(true); //  lock the pcn details "panel" while we edit the letter
            // this.global.lockReasons(true);
            this.global.isPcnClosed = true;
            this.global.isReasonsLocked = true;
            this.global.isLetterTopLocked = true;
            this.global.isPcnDetailsLocked = true;
            // console.log("savePreviewLetter got Result");
            // console.log('Is Reasons Locked? ' + this.global.isReasonsLocked);
            // console.log('Is Letter(Top) Locked? ' + this.global.isLetterTopLocked);
          } else {
            this.globalObs.pushError.next({
              status: 200,
              statusText: 'Success',
              message: 'Letter was not saved!',
              url: '',
              date: new Date(),
            });
            // console.log("savePreviewLetter no Result");
          }
        },
        error: (e) => {
          // console.log('Error saving letter: ', e);
        },
        complete: () => {
          // Force label and state update together before detection
          this.saveLetterLoading = false;
          this.isEditMode = true;

          // console.log('Save Letter Loading: ' + this.saveLetterLoading);
          // console.log('Letter Shown: ' + this.isLetterShown());
          // console.log('Edit Mode: ' + this.isEditMode);
          this.updateButtonLabel();

          // Manually trigger change detection once all updates are in
          this.cdr.detectChanges();
        },
      });
    }
  }

  cancelEditDocument() {
    if (this.isEditMode) {
      this.ckeditorContent = this.letterContent;
      // this.isEditMode = false;
      this.toggleEditMode(false);

      this.showCopyBtn = false;
      // open the pcn, "unlock" the pcn-block, questions and letter functions
      this.pcnService
        .reOpenPcn(this.global.PCN.pcn)
        .subscribe({
          next: () => {},
          error: () => {
            // console.log('Cancel Edit Document ERROR');
          },
          complete: () => {},
        })
        .add(() => {
          this.storageService.lockReasons(false); // unlock the reasons "panel"
          this.storageService.lockLetterTop(false); // unlock the letter top "panel"
          this.storageService.lockPcnDetails(false); // unlock the pcn details "panel"
          this.pcnService.setClosePcn(false);
          this.global.isPcnClosed = false;
          this.global.isReasonsLocked = false;
          this.global.isLetterTopLocked = false;
          this.global.isPcnDetailsLocked = false;
          this.updateButtonLabel();
        });
    } else {
      this.globalObs.onPcnResetRequest.next(true);
    }
  }

  copyLetter(isFormatted: boolean, strategy: string = 'HtmlPlain'): void {
    const html = isFormatted ? this.ckeditorContent : this.clearStyle(this.ckeditorContent);
    this.writeToClipboardWithStrategy(strategy, html, () => {
      this.showCopyOptions = false;
    });
  }

  copyLetterWordFormat() {
    // var copyLetterFunction = this.global.appSettings['LetterEditor.CopyLetterFunction'];
    let copyLetterFunction = '';

    this.settingsService.getApplicationSetting('LetterEditor.CopyLetterFunction').subscribe(
      (result) => {
        copyLetterFunction = result;

        if (copyLetterFunction === 'LetterEditor.CopyLetterFunction') {
          this.copyToClipboardWithDefaultStrategy();
        } else if (copyLetterFunction === 'CopyToWord') {
          this.saveToDoc(true);
        } else {
          this.copyToClipboardWithDefaultStrategy();
        }
      },
      (err) => {
        copyLetterFunction = 'CopyToClipboard';
      }
    );
  }

  private copyToClipboardWithDefaultStrategy(): void {
    // LetterEditor.ClipboardStrategy lets a tenant lock in whichever clipboard
    // strategy the trial dropdown showed works for their NPS
    this.settingsService.getApplicationSetting('LetterEditor.ClipboardStrategy').subscribe(
      (strategy) => {
        this.copyToClipboard(strategy || 'HtmlPlain');
      },
      (err) => {
        this.copyToClipboard('HtmlPlain');
      }
    );
  }

  copyToClipboard(strategy: string = 'HtmlPlain'): void {
    this.writeToClipboardWithStrategy(strategy, this.ckeditorContent);
  }

  setClipboardTrialEnabled(): void {
    this.settingsService.getApplicationSetting('LetterEditor.ClipboardTrialEnabled').subscribe(
      (result) => {
        this.clipboardTrialEnabled = result === 'true';
      },
      (err) => {
        this.clipboardTrialEnabled = false;
      }
    );
  }

  setSpinnerStyle(): void {
    this.settingsService.getApplicationSetting('Council.SpinnerStyle').subscribe(
      (result) => {
        this.spinnerStyle = typeof result === 'string' && result ? result : 'spinner3';
      },
      (err) => {
        this.spinnerStyle = 'spinner3';
      }
    );
  }

  private writeToClipboardWithStrategy(
    strategy: string,
    html: string,
    onSuccess?: () => void
  ): void {
    switch (strategy) {
      case 'HtmlRtfPlain':
        this.writeHtmlRtfPlainToClipboard(html, true, onSuccess);
        break;
      case 'RtfPlain':
        this.writeHtmlRtfPlainToClipboard(html, false, onSuccess);
        break;
      case 'PlainStructured':
        this.writeStructuredPlainTextToClipboard(html, onSuccess);
        break;
      case 'LegacyExecCommandRtf':
        this.writeRtfViaLegacyExecCommand(html, onSuccess);
        break;
      case 'NativeSelectionCopy':
        this.execCommandCopyHtml(html, () => this.flashCopySuccess(onSuccess));
        break;
      case 'HtmlPlain':
      default:
        this.writeToClipboard(html, onSuccess);
        break;
    }
  }

  private writeToClipboard(html: string, onSuccess?: () => void): void {
    const tempEl = document.createElement('div');
    tempEl.innerHTML = html;
    const plain = tempEl.innerText;

    const succeed = () => this.flashCopySuccess(onSuccess);

    if (navigator.clipboard && typeof ClipboardItem !== 'undefined') {
      navigator.clipboard
        .write([
          new ClipboardItem({
            'text/html': new Blob([html], { type: 'text/html' }),
            'text/plain': new Blob([plain], { type: 'text/plain' }),
          }),
        ])
        .then(succeed)
        .catch(() => this.execCommandCopyHtml(html, succeed));
    } else {
      this.execCommandCopyHtml(html, succeed);
    }
  }

  // Trial strategy: adds a text/rtf entry (generated server-side via Aspose) alongside
  // html/plain, or in place of html when includeHtml is false
  private writeHtmlRtfPlainToClipboard(
    html: string,
    includeHtml: boolean,
    onSuccess?: () => void
  ): void {
    const tempEl = document.createElement('div');
    tempEl.innerHTML = html;
    const plain = tempEl.innerText;

    this.letterService.convertHtmlToRtf(html).subscribe({
      next: (rtfBlob) => {
        const items: { [type: string]: Blob } = {
          'text/rtf': rtfBlob,
          'text/plain': new Blob([plain], { type: 'text/plain' }),
        };
        if (includeHtml) {
          items['text/html'] = new Blob([html], { type: 'text/html' });
        }

        const succeed = () => this.flashCopySuccess(onSuccess);

        if (navigator.clipboard && typeof ClipboardItem !== 'undefined') {
          navigator.clipboard
            .write([new ClipboardItem(items)])
            .then(succeed)
            .catch(() => this.execCommandCopyHtml(html, succeed));
        } else {
          this.execCommandCopyHtml(html, succeed);
        }
      },
      error: () => {
        // RTF generation failed - fall back to today's default clipboard write
        this.writeToClipboard(html, onSuccess);
      },
    });
  }

  // Trial strategy: legacy event-driven copy with an explicit setData per MIME type,
  // as opposed to the async Clipboard API's sanitised ClipboardItem write
  private writeRtfViaLegacyExecCommand(html: string, onSuccess?: () => void): void {
    const tempEl = document.createElement('div');
    tempEl.innerHTML = html;
    const plain = tempEl.innerText;

    this.letterService.convertHtmlToRtf(html).subscribe({
      next: (rtfBlob) => {
        rtfBlob.text().then((rtfText) => {
          const handler = (event: ClipboardEvent) => {
            event.preventDefault();
            if (event.clipboardData) {
              event.clipboardData.setData('text/rtf', rtfText);
              event.clipboardData.setData('text/html', html);
              event.clipboardData.setData('text/plain', plain);
            }
          };

          document.addEventListener('copy', handler);
          try {
            document.execCommand('copy');
          } finally {
            document.removeEventListener('copy', handler);
          }
          this.flashCopySuccess(onSuccess);
        });
      },
      error: () => {
        this.writeToClipboard(html, onSuccess);
      },
    });
  }

  // Trial strategy: cheapest fallback - approximates paragraph/list structure with
  // whitespace instead of relying on any rich format surviving the paste
  private writeStructuredPlainTextToClipboard(html: string, onSuccess?: () => void): void {
    const plain = this.toStructuredPlainText(html);
    const succeed = () => this.flashCopySuccess(onSuccess);

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(plain)
        .then(succeed)
        .catch(() => this.execCommandCopyPlainText(plain, succeed));
    } else {
      this.execCommandCopyPlainText(plain, succeed);
    }
  }

  private toStructuredPlainText(html: string): string {
    const structured = html
      .replace(/<\/(p|div|h[1-6]|tr)>/gi, '\n')
      .replace(/<li[^>]*>/gi, '\n\t- ')
      .replace(/<br\s*\/?>/gi, '\n');

    const tempEl = document.createElement('div');
    tempEl.innerHTML = structured;
    return tempEl.innerText.replace(/\n{3,}/g, '\n\n').trim();
  }

  private execCommandCopyPlainText(text: string, onDone: () => void): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    onDone();
  }

  private execCommandCopyHtml(html: string, onDone: () => void): void {
    const div = document.createElement('div');
    div.setAttribute('contenteditable', 'true');
    div.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
    div.innerHTML = html;
    document.body.appendChild(div);
    const range = document.createRange();
    range.selectNodeContents(div);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    document.execCommand('copy');
    sel.removeAllRanges();
    document.body.removeChild(div);
    onDone();
  }

  private flashCopySuccess(onSuccess?: () => void): void {
    if (onSuccess) {
      onSuccess();
    }
    this.isCopyToastShown = true;
    setTimeout(() => {
      this.isCopyToastShown = false;
    }, 2000);
  }

  copyToNps(triggerPaste: boolean = false): void {
    if (!triggerPaste) {
return;
}

    this.settingsService.getApplicationSetting('LetterEditor.NpsPasteUrl').subscribe({
      next: (pasteUrl) => this.triggerPasteToNps(pasteUrl),
      error: () => this.triggerPasteToNps(null),
    });
  }

  private triggerPasteToNps(pasteUrl: string | null): void {
    if (pasteUrl) {
      this.postPasteMessage(pasteUrl);
      return;
    }

    // Fall back to the general NPS url setting if a dedicated paste page isn't configured
    this.settingsService.getApplicationSetting('LetterEditor.NpsUrl').subscribe({
      next: (npsUrl) => this.postPasteMessage(npsUrl),
      error: () =>
        console.error(
          'Cannot trigger paste to NPS - no LetterEditor.NpsPasteUrl/NpsUrl configured.'
        ),
    });
  }

  private postPasteMessage(npsUrl: string): void {
    if (!npsUrl) {
      console.error('Cannot trigger paste to NPS - no NPS URL configured for this client.');
      return;
    }

    // DC's original concern was posting with '*' as the target origin - restricting
    // delivery to our own origin instead means this can't leak the letter content
    // if this script ever ends up running somewhere unexpected.
    window.postMessage(
      { type: 'TRIGGER_PASTE_PCN', npsUrl, letterHtml: this.ckeditorContent },
      window.location.origin
    );
  }

  saveToDoc(isFormatted) {
    let stringContentDoc = '';
    const now = new Date();

    const documentName =
      this.global.PCN.pcn + '_' + this.datePipeEn.transform(now, 'yyyyMMddHHmm') + '.docx';

    if (isFormatted) {
      stringContentDoc = (document.getElementById(this.formattedInputId) as HTMLInputElement).value;
    } else {
      stringContentDoc = (document.getElementById(this.unformattedInputId) as HTMLInputElement)
        .value;
    }

    this.letterService
      .convertHtmlToLetter('<!DOCTYPE html>' + '<body>' + stringContentDoc + '</body>')
      .subscribe({
        next: (result) => {
          if (result) {
            saveAs(result, documentName);
          }
        },
        error: (e) => {},
        complete: () => {},
      });
  }

  // Trial strategy (file-based): same download-then-paste flow as saveToDoc, but
  // opens a lighter .rtf file instead of .docx
  saveToRtf(isFormatted: boolean): void {
    let stringContentDoc = '';
    const now = new Date();

    const documentName =
      this.global.PCN.pcn + '_' + this.datePipeEn.transform(now, 'yyyyMMddHHmm') + '.rtf';

    if (isFormatted) {
      stringContentDoc = (document.getElementById(this.formattedInputId) as HTMLInputElement).value;
    } else {
      stringContentDoc = (document.getElementById(this.unformattedInputId) as HTMLInputElement)
        .value;
    }

    this.letterService
      .convertHtmlToRtf('<!DOCTYPE html>' + '<body>' + stringContentDoc + '</body>')
      .subscribe({
        next: (result) => {
          if (result) {
            saveAs(result, documentName);
          }
        },
        error: (e) => {},
        complete: () => {},
      });
  }

  clearStyle(content) {
    content = content.replace(/style=".*?"/g, '');
    return content;
  }

  getDecisionText() {
    if (this.decisionStatus === this.decisionsConst.upheld.id) {
      return this.decisionsConst.upheld.name;
    } else if (this.decisionStatus === this.decisionsConst.cancel.id) {
      return this.decisionsConst.cancel.name;
    } else if (this.decisionStatus === this.decisionsConst.reqInfo.id) {
      return this.decisionsConst.reqInfo.name;
    } else if (this.decisionStatus === this.decisionsConst.bespokeLetter.id) {
      return this.decisionsConst.bespokeLetter.name;
    }
    return this.decisionsConst.none.name;
  }

  openDecisionModal(modal) {
    // return is the pcn is closed
    if (this.global.isPcnClosed || this.global.isReasonsLocked) {
      return;
    }
    // return on bespoke letter decision
    if (
      this.decisionStatus === this.decisionsConst.bespokeLetter.id &&
      !this.isCreateBespokeLetter
    ) {
      return;
    }
    if (!this.areReasonsSelected()) {
      return;
    }
    if (!this.hasEditLetterAccess && !this.isCreateBespokeLetter) {
      return;
    }
    this.isModalSubmitted = true;
    this.modalReference = this.modalService.open(modal, {
      centered: true,
      windowClass: 'decision-modal-container',
    });
  }

  onSubmitChangeDecision(decisionObj: ChangeDecisionModel) {
    this.changeDecisionBespokeLetterError = '';
    this.letterService.changeDecision(decisionObj).subscribe({
      next: (result) => {
        if (result) {
          // this.loadingState = true;
          this.showSpinner(this.defaultMessage);
          // console.log('onSubmitChangeDecision calling getLetterAsHtml');
          this.getLetterAsHtml();
          this.modalReference.close();
          this.isModalSubmitted = false;
        } else {
          this.modalReference.close();
          this.isModalSubmitted = false;
          this.changeDecisionBespokeLetterError =
            'Could not change the decision. Please try again.';
        }
      },
      error: (e) => {},
    });
  }

  onSubmitBespokeLetter(bespokeLetterObj) {
    this.changeDecisionBespokeLetterError = '';
    this.decisionStatus = this.decisionsConst.none.id;
    this.letterService.createBespokeLetter(bespokeLetterObj).subscribe(
      (result) => {
        if (result) {
          this.loadingState = true;
          // console.log('onSubmitBespokeLetter calling getLetterAsHtml');
          this.getLetterAsHtml();
          this.modalReference.close();
          this.isModalSubmitted = false;
        } else {
          this.modalReference.close();
          this.isModalSubmitted = false;
          this.changeDecisionBespokeLetterError =
            'Could not create bespoke letter. Please try again.';
        }
      },
      (error) => {
        // console.log("Create bespoke letter error");
      }
    );
  }

  onCloseModal() {
    this.isModalSubmitted = false;
    this.modalReference.close();
  }

  getLetterAsHtml() {
    // Cancel any in-flight HTTP request
    if (this.latestLetterRequest) {
      this.latestLetterRequest.unsubscribe();
      this.latestLetterRequest = null;
    }

    // Emit to debounced subject - will trigger executeGetLetterAsHtml after 500ms
    this.letterRequest$.next();
  }

  private executeGetLetterAsHtml() {
    if (!this.global.questionsAndAnswers || this.global.questionsAndAnswers.length === 0) {
      this.hideSpinner();
      return;
    }

    this.globalObs.onLetterChanging.next(true); /* Fire letter changing event */

    this.letterEventCode = '';
    this.letterEventDescription = '';
    const questionAndAnswersList = this.global.questionsAndAnswers;
    const repId = this.global.PCN.repId;

    if (!repId) {
      // onLetterChanging was already emitted above, and onQuestionsChanged
      // showed the spinner before calling in, so returning here without
      // releasing either left the editor busy with no request outstanding and
      // nothing to complete it.
      console.warn(`[Component] No repId found, skipping letter generation.`);
      this.letterGenerationError = this.letterUnavailableMessage;
      this.hideSpinner();
      this.globalObs.onLetterChanged.next(true);
      this.cdr.markForCheck();
      return;
    }

    this.letterGenerationError = '';

    // don't request letter if decision is a bespoke letter
    if (this.decisionStatus === this.decisionsConst.bespokeLetter.id) {
      this.loadingState = false;
      // this.disableLetterBlock = false;
      this.globalObs.onLetterChanged.next(true); /* Fire letter changed event */
      this.cdr.markForCheck();
      return;
    }

    // console.log(`[Component] Calling Letter Service (getLetterAsHtml)`);

    // store the latest request so we can cancel it if needed
    this.latestLetterRequest = this.letterService
      .createLetterAsHtml(repId, questionAndAnswersList)
      .subscribe({
        next: (response) => {
          const result = response.result;
          if (!result.hasError && result.letterContentsHtml) {
            // console.log(`[Component] Letter generation success: `, JSON.stringify(result));

            this.letterTemplatedSelected = result.appliedTemplate;
            this.ckeditorContent = result.letterContentsHtml;

            // fix for Word font-size and font-family issue
            this.ckeditorContent = this.ckeditorContent.replace(/<p /gi, '<div ');
            this.ckeditorContent = this.ckeditorContent.replace(/<\/p>/g, '</div>');

            this.letterContent = this.ckeditorContent;
            this.letterEventCode = result.eventCode;
            this.letterEventDescription = result.eventDescription;

            this.setDecisionStatus(result);
          } else {
            console.error(`[Component] Letter generation error: `, result.errorMessage);
            this.globalObs.pushError.next({
              status: 200,
              statusText: 'Success',
              message: result.errorMessage,
              url: '',
              date: new Date(),
            });
            this.letterGenerationError = result.errorMessage;
          }
        },
        error: (e) => {
          console.error(`[Component] Letter generation failed`, e);

          // The cleanup below is deliberately duplicated from `complete` rather
          // than moved into `finalize`. finalize also runs when
          // getLetterAsHtml() unsubscribes to cancel an in-flight request, and
          // that path is followed by a 500ms debounce before the replacement
          // request starts - so hiding the spinner there would clear the busy
          // state during a window in which work really is still pending.
          //
          // Without this, an error left loadingState true with no request
          // outstanding: `complete` never runs on an errored observable, and the
          // teardown added below only emits onLetterChanged, which clears
          // isLetterChanging and does not touch the spinner. The editor stayed
          // on "loading letter" until the case was reloaded.
          this.letterGenerationError = this.letterFailedMessage;
          this.hideSpinner();
          this.cdr.markForCheck();
        },
        complete: () => {
          // this.loadingState = false;
          this.hideSpinner();
        },
      });

    // ensure UI is unlocked after request completes
    this.latestLetterRequest.add(() => {
      // this.disableLetterBlock = false;
      setTimeout(() => {
        this.globalObs.onLetterChanged.next(true); /* Fire letter changed event */
        this.cdr.markForCheck();
      }, 100);
    });
  }

  isLetterShown() {
    const letterShown =
      (this.areReasonsSelected() &&
        this.decisionStatus !== this.decisionsConst.none.id &&
        this.decisionStatus !== this.decisionsConst.bespokeLetter.id) ||
      this.isCustomLetter;

    return letterShown;
  }

  toggleParagraphsTooltip() {
    // console.log("toggleParagraphsTooltip()");
    if (this.decisionStatus === this.decisionsConst.bespokeLetter.id) {
      return;
    }
    // console.log("Toggling the paragraph tooltip");
    this.isParagraphTooltipVisible = !this.isParagraphTooltipVisible;
  }

  setDecisionStatus(result) {
    const decision = result.decision;
    if (decision !== undefined) {
      if (decision === 1) {
        this.decisionStatus = this.decisionsConst.upheld.id;
      } else if (decision === 2) {
        this.decisionStatus = this.decisionsConst.cancel.id;
      } else {
        this.decisionStatus = this.decisionsConst.reqInfo.id;
      }
    }
  }

  areQuestionsValid() {
    let isValid = true;
    this.global.questionsObjectList.forEach((question) => {
      if (!question.isValid) {
        isValid = false;
      }
    });
    return isValid;
  }

  saveEditedLetter(interfaceDocument) {
    this.letterService.saveEditedLetter(interfaceDocument).subscribe({
      next: (result) => {
        if (result) {
          this.storageService.lockReasons(false); // unlocks the reasons "panel"
          this.storageService.lockPcnDetails(false); // unlocks the reasons "panel"
          this.storageService.lockLetterTop(false); // unlocks the reasons "panel"

          this.pcnService.setClosePcn(false);

          this.global.isPcnClosed = false;
          this.global.isReasonsLocked = false;
          this.global.isLetterTopLocked = false;
          this.global.isPcnDetailsLocked = false;
          this.globalObs.onPcnResetRequest.next(true);
        } else {
          this.globalObs.pushError.next({
            status: 200,
            statusText: 'Success',
            message: 'Edited letter was not saved!',
            url: '',
            date: new Date(),
          });
          // console.log("saveEditedLetterFailed");
        }
      },
      error: (e) => {},
      complete: () => {
        this.saveLetterLoading = false;
      },
    });
  }

  saveInterfaceAndEditedLetter() {
    const documentHtml = (document.getElementById(this.formattedInputId) as HTMLInputElement).value;
    const token = this.global.encryptedToken;
    const interfaceDocument: InterfaceDocument = {
      htmlLetter: documentHtml,
      token,
      isInterfaceDocument: true,
    };

    if (!this.global.isTokenValid || this.global.encryptedToken === '') {
      interfaceDocument.isInterfaceDocument = false;
    }

    this.saveEditedLetter(interfaceDocument);

    // console.log("passing to saveEditedLetter");

    this.global.encryptedToken = '';
    this.global.isTokenValid = false;

    // console.log(interfaceDocument);
  }

  onQuestionsChanging() {
    this.showSpinner(this.waitingForQuestionsMessage);
  }

  /**
   * A question refresh finished without succeeding.
   *
   * Releases the busy state that onQuestionsChanging claimed, and deliberately
   * does *not* call getLetterAsHtml(). The answers held on screen are the ones
   * from before the failed refresh, so rebuilding the letter from them would
   * produce a statutory notice from state that is not known to be current -
   * quietly, because it would look like an ordinary regeneration.
   *
   * onLetterChanged is emitted for the same reason it is on the
   * letter-unavailable path: it is what clears isLetterChanging in the other
   * components, and hideSpinner alone does not touch it.
   */
  onQuestionsFailed() {
    this.letterGenerationError = this.questionsFailedMessage;
    this.hideSpinner();
    this.globalObs.onLetterChanged.next(true);
    this.cdr.markForCheck();
  }

  onQuestionsChanged() {
    // console.log("Questions have changed (letter)");
    if (!this.areQuestionsValid()) {
      this.showSpinner('Please make sure you have answered all the questions.');
      this.letterGenerationError = ' ';
      return;
    }
    // this.loadingState = true;
    this.showSpinner(this.loadingLetterMessage);
    // console.log('onQuestionsChanged called getLetterAsHtml');
    // console.log('onQuestionsChanged calling getLetterAsHtml');
    this.getLetterAsHtml();
    this.setSelectedCustomParagraphs();
  }

  onReasonsChanging() {
    // this.loadingState = true;
    this.showSpinner(this.waitingForQuestionsMessage);

    // hide custom letters on reason change
    if (this.isCustomLetterVisible) {
      this.isCustomLetterVisible = !this.isCustomLetterVisible;
      // this.openCustomLetter();
      this.openCustomLetter(this.isCustomLetterVisible);
    }
    // hide custom paragraphs on reason change
    if (this.isCustomParagraphVisible) {
      this.isCustomParagraphVisible = !this.isCustomParagraphVisible;
      // this.openCustomParagraph();
      this.openCustomParagraph(this.isCustomParagraphVisible);
    }
  }

  onReasonsChanged() {
    // clear exsiting letter generation errors
    this.letterGenerationError = '';

    this.showSpinner(this.waitingForQuestionsMessage);
  }

  onDocumentsChanging() {
    this.loadingState = true;
  }

  onDocumentsChanged() {
    // Paragraphs arrive through onCustomParagraphsChanged.
  }

  onAddCustomLetter() {
    this.isCustomLetter = true;
    this.showSpinner(this.defaultMessage);
    this.decisionStatus = this.decisionsConst.none.id;
    this.getLetterAsHtml();
    this.hideSpinner();
  }

  onRemoveCustomLetter() {
    this.isCustomLetter = false;
    this.showSpinner(this.defaultMessage);
    this.decisionStatus = this.decisionsConst.none.id;
    this.getLetterAsHtml();
    this.hideSpinner();
  }

  onAddCustomParagraph() {
    this.showSpinner(this.defaultMessage);
    this.decisionStatus = this.decisionsConst.none.id;
    this.getLetterAsHtml();
    this.hideSpinner();
  }

  onRemoveCustomParagraph() {
    this.showSpinner(this.defaultMessage);
    this.decisionStatus = this.decisionsConst.none.id;
    this.getLetterAsHtml();
    this.hideSpinner();
  }

  onDecisionSet(decisionAction: string) {
    if (
      this.global.decisionActions[decisionAction.toString()] ===
      this.questionsConst.createBespokeLetterAction
    ) {
      this.decisionStatus = this.decisionsConst.bespokeLetter.id;
    } else {
      this.decisionStatus = this.decisionsConst.none.id;
    }
  }

  // global event
  onDocumentClick(event) {
    if (
      this.paragraphsTooltip !== undefined &&
      this.paragraphLabel !== undefined &&
      !this.paragraphsTooltip.nativeElement.contains(event.target) &&
      !this.paragraphLabel.nativeElement.contains(event.target)
    ) {
      this.isParagraphTooltipVisible = false;
    }
    // close copy and save letter buttons tooltip
    if (
      this.copyLetterBtn !== undefined &&
      !this.copyLetterBtn.nativeElement.contains(event.target)
    ) {
      this.showCopyOptions = false;
    }
  }

  toggleCustomParagraph() {
    this.isCustomParagraphVisible = !this.isCustomParagraphVisible;
    this.openCustomParagraph(this.isCustomParagraphVisible);
  }

  openCustomParagraph(visibility: boolean) {
    this.globalObs.onCustomParagraphsShow.next(visibility);
  }

  toggleCustomLetter() {
    this.isCustomLetterVisible = !this.isCustomLetterVisible;
    this.openCustomLetter(this.isCustomLetterVisible);
  }

  openCustomLetter(visibility: boolean) {
    this.globalObs.onCustomLettersShow.next(visibility);
  }

  onCustomLettersChanged() {
    this.customLetters = this.global.customLetters;
    this.bounceLettersBubbleState = Math.random();
  }

  onCustomParagraphsChanged() {
    this.setCustomParagraphs();
  }

  areReasonsSelected() {
    return this.reasonService.getLocalReasons().length > 0;
  }

  toggleShowCopyOptions() {
    this.showCopyOptions = !this.showCopyOptions;
    this.cdr.detectChanges(); // force sync detection
  }

  public close() {
    this.showCancelLetterDialog = false;
  }

  public open() {
    this.showCancelLetterDialog = true;
  }

  ngOnDestroy() {
    this.letterRequestSubscription?.unsubscribe();
    this.letterRequest$.complete();
    this.latestLetterRequest?.unsubscribe();
    this.onAddCustomParagraphEvent?.unsubscribe();
    this.onRemoveCustomParagraphEvent?.unsubscribe();
    this.onAddCustomLetterEvent?.unsubscribe();
    this.onRemoveCustomLetterEvent?.unsubscribe();
    this.onPcnChangedEvent?.unsubscribe();
    this.onQuestionsChangingEvent?.unsubscribe();
    this.onQuestionsChangedEvent?.unsubscribe();
    this.onQuestionsFailedEvent?.unsubscribe();
    this.onDocumentsChangingEvent?.unsubscribe();
    this.onDocumentsChangedEvent?.unsubscribe();
    this.onAfterDocumentsSaved?.unsubscribe();
    this.addCustomLetterSubscription?.unsubscribe();
    this.removeCustomLetterSubscription?.unsubscribe();
    this.addCustomParagraphSubscription?.unsubscribe();
    this.removeCustomParagraphSubscription?.unsubscribe();
    this.onDecisionSetActionEvent?.unsubscribe();
    this.onCustomLettersChangedEvent?.unsubscribe();
    this.onCustomParagraphsChangedEvent?.unsubscribe();
    this.onReasonsChangedEvent?.unsubscribe();
    this.onReasonsChangingEvent?.unsubscribe();
  }

  private hideSpinner() {
    if (this.loadingState) {
      this.loadingState = false;
      this.loadingMessage = '';
    }
  }

  private showSpinner(message: string) {
    // check if there are any reasons selected
    if (!this.areReasonsSelected()) {
      this.loadingMessage = this.noReasonsSelectedMessage;
    } else if (!this.areQuestionsValid()) {
      this.loadingMessage = this.unansweredQuestionsMessage;
    } else {
      this.loadingMessage = this.waitingForQuestionsMessage;
    }

    if (message !== undefined) {
      this.loadingMessage = message;
    } else {
      this.loadingMessage = this.defaultMessage;
    }

    if (!this.loadingState) {
      // console.log(`[Component] Showing spinner setting loadingState to true`);
      this.loadingState = true;
    }
  }

  private updateButtonLabel(): void {
    this._buttonLabel = this.saveLetterLoading
      ? 'Saving...'
      : this.isEditMode
        ? 'Save and Finish'
        : 'Save and Edit';

    // console.log('[DEBUG] Label updated:', this._buttonLabel);
  }
}
